export { SimpleTabs } from "./slider-tabs";
